import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BreadCrumbs from '@lib/components/BreadCrumbs/BreadCrumbs';
import PageHeader from '@lib/layouts/DashboardLayout/PageHeader/PageHeader';
import PageBody from '@lib/layouts/DashboardLayout/PageBody/PageBody';
import FeatureLockState from '@lib/components/FeatureLockState';
import Trans from '@lib/components/Trans/Trans';
import { PlanState } from '@lib/enums/plan';
import {
  CompanyPlanUpgradeFeatureEnum,
  AccessComponentEnum,
  AccessLevelEnum,
} from 'graphql-common';
import { getBreadCrumbsDataByKey } from 'utils/breadcrumbs';
import useOutletContext, { ContextProps } from 'hooks/useOutletContext';
import DocumentAnalyticsContent from './DocumentAnalyticsContent';

export default function DocumentAnalytics() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { getUserAccessByCompany, handleOpenPlanModal }: ContextProps =
    useOutletContext();
  const isPlanLocked =
    getUserAccessByCompany(AccessComponentEnum.DocumentationManagement) ===
    AccessLevelEnum.LimitedRead;

  return (
    <>
      <BreadCrumbs data={getBreadCrumbsDataByKey({ pathname, t })} />
      <PageHeader title={t('analytics')} />
      {isPlanLocked ? (
        <PageBody>
          <FeatureLockState
            title={t('unlock-document-analytics')}
            text={<Trans i18nKey="unlock-document-analytics-text" />}
            onUpgrade={() =>
              handleOpenPlanModal(PlanState.Locked, [
                CompanyPlanUpgradeFeatureEnum.Documentation,
              ])
            }
          />
        </PageBody>
      ) : (
        <DocumentAnalyticsContent />
      )}
    </>
  );
}
